import { HiExclamation } from "react-icons/hi";
import { CustomButton } from "../atoms/CustomButton";
import { ModalShell } from "../atoms/ModalShell";
import { ReactNode } from "react";

const ConfirmModal = ({
  show,
  onClose,
  title,
  description,
  cancelBtnName,
  cancelBtnFn,
  confirmBtnName,
  confirmBtnFn,
  disabled = false,
  isLoading = false,
  ConfirmBtnColor = "blue",
  icon,
  iconBgColor = "bg-amber-100",
  iconColor = "text-amber-600",
  iconStyle,
}: {
  show: boolean;
  onClose: (value: boolean) => void;
  title: string;
  description: string | ReactNode;
  cancelBtnName: string;
  cancelBtnFn: (value: boolean) => void;
  confirmBtnName: string;
  confirmBtnFn: () => void;
  disabled?: boolean;
  isLoading?: boolean;
  ConfirmBtnColor?: "red" | "blue";
  icon?: ReactNode;
  iconBgColor?: string;
  iconColor?: string;
  iconStyle?: string;
}) => {
  return (
    <ModalShell
      show={show}
      onClose={() => onClose(false)}
      size="md"
      footer={
        <>
          <CustomButton
            onClick={() => cancelBtnFn(false)}
            disabled={isLoading}
            title={cancelBtnName}
          />
          <CustomButton
            variant={ConfirmBtnColor === "red" ? "danger" : "primary"}
            onClick={confirmBtnFn}
            disabled={disabled || isLoading}
            isLoading={isLoading}
            title={confirmBtnName}
          />
        </>
      }
    >
      <div className="flex flex-col items-center gap-3 text-center">
        <div
          className={
            iconStyle ||
            `w-10 h-10 rounded-full ${iconBgColor} flex items-center justify-center`
          }
        >
          {icon || <HiExclamation size={24} className={iconColor} />}
        </div>

        <div className="flex flex-col gap-2">
          <div className="text-gray-900 text-lg font-semibold leading-7">
            {title}
          </div>
          <div className="text-gray-500 text-sm leading-tight">
            {description}
          </div>
        </div>
      </div>
    </ModalShell>
  );
};

export default ConfirmModal;
